import { Component, OnInit } from '@angular/core';
import * as backInter from 'app/auth/auth-data.model';
import { ColaboradoresEncuestadorService } from 'app/main/wizard-n35encuestador/services/colaboradoresEncuestador.service';
import {MatTableDataSource} from '@angular/material/table';
import { WizardService } from 'app/main/wizard-n35/services/wizard.service';
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { lang_resultados35 } from 'app/idiomas/i18n/resultados35/resultados35.lang';
import { fuseAnimations } from '@fuse/animations';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2';
import {TranslateService} from '@ngx-translate/core';
//import * as colabInter from './centros-de-trabajo.interfaces.ts';
@Component({
  selector: 'app-centros-de-trabajo',
  templateUrl: './centros-de-trabajo.component.html',
  styleUrls: ['./centros-de-trabajo.component.scss'],
  animations : fuseAnimations
})
export class CentrosDeTrabajoComponent implements OnInit {
  ClavesMas50: string[] = [
    'Ambiente de trabajo',
    'Ambiente de trabajo_COLOR',
    'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO',
    'CARGO O FUNCIÓN HOMOLOGADO',
    'Carga de trabajo',
    'Carga de trabajo_COLOR',
    'Condiciones en el ambiente de trabajo',
    'Condiciones en el ambiente de trabajo_COLOR',
    'Entorno organizacional',
    'Entorno organizacional_COLOR',
    'Factores propios de la actividad',
    'Factores propios de la actividad_COLOR',
    'Falta de control sobre el trabajo',
    'Falta de control sobre el trabajo_COLOR',
    'GRADO ACADÉMICO',
    'GÉNERO',
    'Insuficiente sentido de pertenencia e, inestabilid',
    'Insuficiente sentido de pertenencia e, inestabilid_COLOR',
    'Interferencia en la relación trabajo-familia',
    'Interferencia en la relación trabajo-familia_COLOR',
    'Jornada de trabajo',
    'Jornada de trabajo_COLOR',
    'Liderazgo',
    'Liderazgo y relaciones en el trabajo',
    'Liderazgo y relaciones en el trabajo_COLOR',
    'Liderazgo_COLOR',
    'NOMBRE DEL COLABORADOR',
    'NivelEstructural_1',
    'NivelEstructural_2',
    'NivelEstructural_3',
    'NivelEstructural_4',
    'NivelEstructural_5',
    'NivelEstructural_6' ,
    'NivelEstructural_7',
    'NivelEstructural_8',
    'NivelEstructural_9',
    'NivelEstructural_10',
    'NivelGeográfico_1',
    'NivelGeográfico_2',
    'NivelGeográfico_3',
    'NivelGeográfico_4',
    'NivelGeográfico_5',
    'Organización del tiempo de trabajo',
    'Organización del tiempo de trabajo_COLOR',
    'Reconocimiento del desempeño',
    'Reconocimiento del desempeño_COLOR',
    'Relaciones en el trabajo',
    'Relaciones en el trabajo_COLOR',
    'Violencia',
    'Violencia_COLOR',
  ]
  productoCertificar: backInter.prodNorma35;
  centroT:any;
  info:any;
  fechaCertificar: any;
  typeContent:number;
  idNorma35:any;
  ctTrabajo:any;
  idctTrabajo:any;
  cargando:boolean=true;
  dataSource: MatTableDataSource<backInter.bdCentrosTrabajo>;
  displayedColumns: string[] = ['nombre', 'direccion','tipoCT', 'accion', 'download'];

  constructor(
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private colaboradoresService: ColaboradoresEncuestadorService,
    private wizardService: WizardService,
    private translateSrv: TranslateService
  ) {
    lang_wizard.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });

    lang_resultados35.forEach((locale) => {
      this._fuseTranslationLoaderService.loadTranslations(locale);
    });
   }

  ngOnInit() {
    this.obtieneCertificarActual();
  }

  centroTrabajoSeleccionado(dato:any, ctID:any){
    this.centroT=dato;
    this.idctTrabajo=ctID;
    localStorage.setItem("ctProductoId", this.centroT);
    localStorage.setItem("ctSeleccionadoId", this.idctTrabajo);
  }

  obtieneCertificarActual(){
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      //console.log("Data certifiar");
      //console.log(data);
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            this.idNorma35=producto.idNorma35;
            console.log(this.idNorma35);
            this.getCentrosDeTrabajo(this.idNorma35);
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              this.typeContent=this.productoCertificar.tipo;
              console.log("TYypeContent "+this.typeContent);
                 // CENTROS DE TRABAJO HIJOS
                 this.info=this.colaboradoresService.getinfo();
               // FIN CENTRO DE TRABAJO HIJO
              throw BreakException;
            }
          }
          });
      } catch (e) {
        if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }
  noCentros:boolean=false;
  getCentrosDeTrabajo(idNorma:any){
    let datos={
      productoId: idNorma
    };
    this.wizardService.getCentrosDeTrabajo(datos).subscribe( (datos:backInter.centrosDeTrabajo) => {
      //console.log(datos.bdcentrosTrabajo);
      //console.log("CENTROS DE TRABAJO");
      //console.log(datos.bdcentrosTrabajo);
      if(datos.bdcentrosTrabajo.length == 0){
        this.noCentros=true;
      }
      this.dataSource = new MatTableDataSource(datos.bdcentrosTrabajo);
      this.ctTrabajo=datos.bdcentrosTrabajo;

      this.dataSource.filterPredicate = (data, filterValue: string)  => {
        const accumulator = (currentTerm, key) => {
          //console.log(data);
          return key === 'bdcentrosTrabajo' ? currentTerm : currentTerm + data[key];
        };
        const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
        //console.log(data.encuestas);
        // console.log(dataStr);
        // Transform the filterValue by converting it to lowercase and removing whitespace.
        const transformedFilter = filterValue.trim().toLowerCase();
        return dataStr.indexOf(transformedFilter) !== -1;
      }
      this.cargando=false;
    });
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    this.ctTrabajo=this.dataSource.filteredData;
  }
  Results:any;
  posColaborador=0;
  posColumnasColaborador=0;
  ColaboradorResult_tmp:any=[];
  ValueObject:any=[];

  descargarResultados(productoId, Idct_numerico, totalColaboradores, nombreCT){

    console.log("este es el nombre ",nombreCT);

    this.modalGuardado();
    this.wizardService.DescargarResultados(productoId,Idct_numerico).subscribe( (datos:any) => {

      if(totalColaboradores > 50){
        this.mas50(datos,nombreCT.substr(0,25));
      }else{
        console.log("entro este de menos50");

        this.menos50(datos,nombreCT.substr(0,25));
      }


    });
  }

  mas50(datos,nombreCT){
    console.log("entro este de menos50 EXCEL");

    var wb = XLSX.utils.book_new();
      wb.Props = {
        Title: "Resultados de Norma 35 "+nombreCT,
        Subject: "Resultados",
        Author: 'Autor',
        CreatedDate: new Date()
      };
      wb.SheetNames.push(nombreCT);
      if(datos.success){
        this.Results=datos.records;
        var ws_data = [];
        let nombresColumnas:string[] = [];
        backInter.ExcelResultMas501.forEach( (nombreColumn) =>{
          switch(nombreColumn){
            case 'NOMBRE DEL COLABORADOR':nombresColumnas.push(nombreColumn);  break;
            case 'NivelGeográfico_1':nombresColumnas.push(nombreColumn);  break;
            case 'NivelGeográfico_2':nombresColumnas.push(nombreColumn);  break;
            case 'NivelGeográfico_3':nombresColumnas.push(nombreColumn);  break;
            case 'NivelGeográfico_4':nombresColumnas.push(nombreColumn);  break;
            case 'NivelGeográfico_5':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_1':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_2':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_3':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_4':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_5':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_6':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_7':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_8':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_9':nombresColumnas.push(nombreColumn);  break;
            case 'NivelEstructural_10':nombresColumnas.push(nombreColumn);  break;
            case 'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO':nombresColumnas.push(nombreColumn);  break;
            case 'CARGO O FUNCIÓN HOMOLOGADO':nombresColumnas.push(nombreColumn);  break;
            case 'GÉNERO':nombresColumnas.push(nombreColumn);  break;
            case 'GRADO ACADÉMICO':nombresColumnas.push(nombreColumn);  break;
            case 'Condiciones en el ambiente de trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Ambiente de trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Carga de trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Falta de control sobre el trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Factores propios de la actividad':nombresColumnas.push(nombreColumn);  break;
            case 'Jornada de trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Interferencia en la relación trabajo-familia':nombresColumnas.push(nombreColumn);  break;
            case 'Organización del tiempo de trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Liderazgo':nombresColumnas.push(nombreColumn);  break;
            case 'Relaciones en el trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Violencia':nombresColumnas.push(nombreColumn);  break;
            case 'Liderazgo y relaciones en el trabajo':nombresColumnas.push(nombreColumn);  break;
            case 'Reconocimiento del desempeño':nombresColumnas.push(nombreColumn);  break;
            case 'Insuficiente sentido de pertenencia e, inestabilid':nombresColumnas.push(nombreColumn);  break;
            case 'Entorno organizacional':nombresColumnas.push(nombreColumn);  break;

          }
        });
        ws_data.push(nombresColumnas);
        this.Results.forEach( (nombre) => {
          let datosColaboradores:any[] = [];
          for (const [key, value] of Object.entries(nombre)) {
            switch(key){
              case 'Ambiente de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Ambiente de trabajo_COLOR':  break;
              case 'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO': datosColaboradores.push(`${value}` );  break;
              case 'CARGO O FUNCIÓN HOMOLOGADO': datosColaboradores.push(`${value}` );  break;
              case 'Carga de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Carga de trabajo_COLOR': break;
              case 'Condiciones en el ambiente de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Condiciones en el ambiente de trabajo_COLOR': break;
              case 'Entorno organizacional': datosColaboradores.push(`${value}` );  break;
              case 'Entorno organizacional_COLOR': break;
              case 'Factores propios de la actividad': datosColaboradores.push(`${value}` );  break;
              case 'Factores propios de la actividad_COLOR': break;
              case 'Falta de control sobre el trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Falta de control sobre el trabajo_COLOR': break;
              case 'GRADO ACADÉMICO': datosColaboradores.push(`${value}` );  break;
              case 'GÉNERO': datosColaboradores.push(`${value}`);  break;
              case 'Insuficiente sentido de pertenencia e, inestabilid': datosColaboradores.push(`${value}` );  break;
              case 'Insuficiente sentido de pertenencia e, inestabilid_COLOR': break;
              case 'Interferencia en la relación trabajo-familia': datosColaboradores.push(`${value}` );  break;
              case 'Interferencia en la relación trabajo-familia_COLOR': break;
              case 'Jornada de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Jornada de trabajo_COLOR': break;
              case 'Liderazgo': datosColaboradores.push(`${value}` );  break;
              case 'Liderazgo y relaciones en el trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Liderazgo y relaciones en el trabajo_COLOR': break;
              case 'Liderazgo_COLOR': break;
              case 'NOMBRE DEL COLABORADOR': datosColaboradores.push(`${value}` );  break;
              case 'NivelEstructural_1': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_2': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_3': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_4': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_5': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_6' : if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_7': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_8': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_9': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelEstructural_10': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelGeográfico_1': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelGeográfico_2': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelGeográfico_3': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelGeográfico_4': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'NivelGeográfico_5': if(value){ datosColaboradores.push(`${value}`); }else{ datosColaboradores.push('N/A')} break;
              case 'Organización del tiempo de trabajo': datosColaboradores.push(`${value}`);  break;
              case 'Organización del tiempo de trabajo_COLOR': break;
              case 'Reconocimiento del desempeño': datosColaboradores.push(`${value}`);  break;
              case 'Reconocimiento del desempeño_COLOR': break;
              case 'Relaciones en el trabajo': datosColaboradores.push(`${value}`);  break;
              case 'Relaciones en el trabajo_COLOR': break;
              case 'Violencia': datosColaboradores.push(`${value}`);  break;
              case 'Violencia_COLOR': break;
            }
          }
          ws_data.push(datosColaboradores);
        });
        console.log(ws_data);
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[nombreCT] = ws;
        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        let texto_result = 'SECCIONES.EXCEL.RESULTS';
        this.translateSrv.get(texto_result).subscribe((res: string) => { texto_result = res; });

        saveAs(new Blob([buf],{type:"application/octet-stream"}),texto_result+nombreCT+'.xlsx');
        Swal.close();
      }
  }

  menos50(datos,nombreCT){

    var wb = XLSX.utils.book_new();
    wb.Props = {
      Title: "Resultados de Norma 35 "+nombreCT,
      Subject: "Resultados",
      Author: 'Autor',
      CreatedDate: new Date()
    };
    wb.SheetNames.push(nombreCT);
    if(datos.success){
      this.Results=datos.records;
      var ws_data = [];
      let nombresColumnas:string[] = [];
      backInter.ExcelResultMas501.forEach( (nombreColumn) =>{
        switch(nombreColumn){
          case 'NOMBRE DEL COLABORADOR':nombresColumnas.push(nombreColumn);  break;
          case 'NivelGeográfico_1':nombresColumnas.push(nombreColumn);  break;
          case 'NivelGeográfico_2':nombresColumnas.push(nombreColumn);  break;
          case 'NivelGeográfico_3':nombresColumnas.push(nombreColumn);  break;
          case 'NivelGeográfico_5':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_1':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_2':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_3':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_4':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_5':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_6':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_7':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_8':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_9':nombresColumnas.push(nombreColumn);  break;
          case 'NivelEstructural_10':nombresColumnas.push(nombreColumn);  break;
          case 'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO':nombresColumnas.push(nombreColumn);  break;
          case 'CARGO O FUNCIÓN HOMOLOGADO':nombresColumnas.push(nombreColumn);  break;
          case 'GÉNERO':nombresColumnas.push(nombreColumn);  break;
          case 'GRADO ACADÉMICO':nombresColumnas.push(nombreColumn);  break;
          case 'Condiciones en el ambiente de trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Ambiente de trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Carga de trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Falta de control sobre el trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Factores propios de la actividad':nombresColumnas.push(nombreColumn);  break;
          case 'Jornada de trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Interferencia en la relación trabajo-familia':nombresColumnas.push(nombreColumn);  break;
          case 'Organización del tiempo de trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Liderazgo':nombresColumnas.push(nombreColumn);  break;
          case 'Relaciones en el trabajo':nombresColumnas.push(nombreColumn);  break;
          case 'Violencia':nombresColumnas.push(nombreColumn);  break;
          case 'Liderazgo y relaciones en el trabajo':nombresColumnas.push(nombreColumn);  break;
        }
      });
       ws_data.push(nombresColumnas);
        this.Results.forEach( (nombre) => {
          let datosColaboradores:any[] = [];
          for (const [key, value] of Object.entries(nombre)) {
            switch(key){
              case 'NOMBRE DEL COLABORADOR': datosColaboradores.push(`${value}` );  break;
              case 'NivelGeográfico_1': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelGeográfico_2': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelGeográfico_3': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelGeográfico_4:': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelGeográfico_5': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_1': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_2': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_3': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_4': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_5': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_6': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_7': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_8': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_9': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'NivelEstructural_10': if(value){ datosColaboradores.push(`${value}` ); }else{ datosColaboradores.push('N/A')}  break;
              case 'CARGO O FUNCIÓN EN EL CENTRO DE TRABAJO': datosColaboradores.push(`${value}` );  break;
              case 'CARGO O FUNCIÓN HOMOLOGADO': datosColaboradores.push(`${value}` );  break;
              case 'GÉNERO': datosColaboradores.push(`${value}` );  break;
              case 'GRADO ACADÉMICO': datosColaboradores.push(`${value}` );  break;
              case 'Condiciones en el ambiente de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Ambiente de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Carga de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Falta de control sobre el trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Factores propios de la actividad': datosColaboradores.push(`${value}` );  break;
              case 'Jornada de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Interferencia en la relación trabajo-familia': datosColaboradores.push(`${value}` );  break;
              case 'Organización del tiempo de trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Liderazgo': datosColaboradores.push(`${value}` );  break;
              case 'Relaciones en el trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Violencia': datosColaboradores.push(`${value}` );  break;
              case 'Liderazgo y relaciones en el trabajo': datosColaboradores.push(`${value}` );  break;
              case 'Reconocimiento del desempeño': datosColaboradores.push(`${value}` );  break;
              case 'Insuficiente sentido de pertenencia e, inestabilid': datosColaboradores.push(`${value}` );  break;
              case 'Entorno organizacional': datosColaboradores.push(`${value}` );  break;
            }
            //console.log(`${key}: ${value}`);
          }
          ws_data.push(datosColaboradores);
        });
        console.log(ws_data);
        var ws = XLSX.utils.aoa_to_sheet(ws_data);
        wb.Sheets[nombreCT] = ws;
        var wbout = XLSX.write(wb, {bookType:'xlsx',  type: 'binary'});
        var buf = new ArrayBuffer(wbout.length); //convert s to arrayBuffer
        var view = new Uint8Array(buf);  //create uint8array as viewer
        for (var i=0; i<wbout.length; i++) view[i] = wbout.charCodeAt(i) & 0xFF; //convert to octet

        let texto_result = 'SECCIONES.EXCEL.RESULTS';
        this.translateSrv.get(texto_result).subscribe((res: string) => { texto_result = res; });
        saveAs(new Blob([buf],{type:"application/octet-stream"}),texto_result+nombreCT+'.xlsx');
        Swal.close();

    }
  }


  modalGuardado(){
    let mensaje = 'SECCIONES.EXCEL.DESCARG_EXCEL';
    this.translateSrv.get(mensaje).subscribe((res: string) => { mensaje = res; });
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });
  }
}
